import SectionHeading from "@/components/SectionHeading";
import { Stagger, StaggerItem, FadeUp } from "@/components/Reveal";
import { ArrowButton } from "@/components/ArrowButton";
import { waTopic, slugify } from "@/data/site";

const DEMANDAS = [
  "Ansiedade e emoções",
  "Atenção e concentração",
  "Organização",
  "Comportamento",
  "Desenvolvimento infantil",
  "Dificuldades escolares",
  "Aprendizagem",
  "Memória",
  "Dúvidas sobre TDAH",
  "Dúvidas sobre TEA",
  "Avaliação Neuropsicológica",
  "Reavaliação",
];

const Demandas = () => (
  <section data-testid="demandas-section" className="bg-cream py-20 lg:py-28">
    <div className="container-x">
      <div className="flex items-end justify-between gap-8">
        <SectionHeading
          eyebrow="01 — Você aqui"
          title="O que trouxe você até aqui?"
          testId="demandas"
        />
      </div>
      <Stagger className="mt-12 flex flex-wrap gap-3" gap={0.05}>
        {DEMANDAS.map((d) => (
          <StaggerItem key={d}>
            <a
              href={waTopic(d.toLowerCase())}
              target="_blank"
              rel="noopener noreferrer"
              data-testid={`demanda-chip-${slugify(d)}`}
              className="inline-block rounded-full border border-raiz-800/20 bg-paper px-5 py-2.5 text-sm text-raiz-900 transition-all duration-300 hover:-translate-y-0.5 hover:border-raiz-800 hover:bg-raiz-800 hover:text-paper"
            >
              {d}
            </a>
          </StaggerItem>
        ))}
      </Stagger>
      <FadeUp delay={0.15} className="mt-12 max-w-2xl">
        <p className="font-serif text-lg italic leading-relaxed text-ink/70">
          Nem sempre é necessário saber exatamente qual atendimento procurar. O primeiro contato também pode ajudar a compreender qual serviço pode fazer sentido para a sua demanda.
        </p>
        <div className="mt-8">
          <ArrowButton to="/por-onde-comecar" testId="demandas-cta-button">
            Por onde começar?
          </ArrowButton>
        </div>
      </FadeUp>
    </div>
  </section>
);

export default Demandas;
